module.exports = __webpack_public_path__ + "img/icon-smiley1.svg";